export default "__VITE_ASSET__QyV4TReK__"